export default __webpack_public_path__ + "static/media/publication_icon.53217e83.svg";